// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strips-LeftBox {
  display: grid;
  place-items: center;
  grid-template-rows: repeat(5, auto);
  grid-row-gap: 2vh;
}
.strips-logo {
  display: grid;
  width: 80%;
  place-items: center;
}
.strips-perslogo {
  display: grid;
  width: 100%;
  pointer-events: none;
}
.strips-subtitle {
  font-family: "Amatic SC";
  font-size: 3vw;
}
.strips-icon {
  width: 100%;
  border-radius: 1vh;
}
.strips-buttonLeftBox {
  border-radius: 1vh;
  display: grid;
  width: 12vw;
  height: 3vw;
  cursor: pointer;
  color: white;
  font-size: 2vw;
  bottom: 1vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/StripesApp/styles/StripesLeftBox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".strips-LeftBox {\n  display: grid;\n  place-items: center;\n  grid-template-rows: repeat(5, auto);\n  grid-row-gap: 2vh;\n}\n.strips-logo {\n  display: grid;\n  width: 80%;\n  place-items: center;\n}\n.strips-perslogo {\n  display: grid;\n  width: 100%;\n  pointer-events: none;\n}\n.strips-subtitle {\n  font-family: \"Amatic SC\";\n  font-size: 3vw;\n}\n.strips-icon {\n  width: 100%;\n  border-radius: 1vh;\n}\n.strips-buttonLeftBox {\n  border-radius: 1vh;\n  display: grid;\n  width: 12vw;\n  height: 3vw;\n  cursor: pointer;\n  color: white;\n  font-size: 2vw;\n  bottom: 1vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
